import React from 'react';
import PropTypes from 'prop-types';
import { at } from 'lodash';
import { useField } from 'formik';
import {
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  FormHelperText
} from '@mui/material';
import { NumericFormat } from 'react-number-format';

function SelectField(props) {
  const { label, name, data, readOnly, onChange, multiple, ...rest } = props;
  const [field, meta, helpers] = useField(props);
  const value = multiple ? (field.value || []) : (field.value || '');
  const [touched, error] = at(meta, 'touched', 'error');
  const isError = touched && error && true;
  const _renderHelperText = () => {
    if (isError) {
      return <FormHelperText>{error}</FormHelperText>;
    }

    return false;
  }

  const handleChange = (event) => {
    helpers.setValue(event.target.value); // Update Formik field value
    if (onChange) {
      onChange(event); // Call the provided onChange function
    }
  };

  return (
    <FormControl {...rest} error={isError}>
      <InputLabel>{label}</InputLabel>
      <Select
        {...field}
        label={label}
        value={value}
        inputProps={{ readOnly }}
        onChange={handleChange}
        multiple={multiple}
        renderValue={
          multiple
            ? (selected) => {
                if (selected.length === 0) return <em>Pilih {label}</em>;
                // Bisa tampilkan label, bukan value (opsional improvement)
                const labels = data.filter(d => selected.includes(d.value)).map(d => d.label);
                return labels.join(', ');
              }
            : undefined
        }
      >
        {data.map((item, index) => (
          <MenuItem key={index} value={item.value}>
            {name === 'gaji'
              ? (<NumericFormat displayType="text" value={parseFloat(item.label)} thousandSeparator="," />)
              : item.label}
          </MenuItem>
        ))}
      </Select>
      {_renderHelperText()}
    </FormControl>
  );
}

SelectField.defaultProps = {
  data: [],
  multiple: false
};

SelectField.propTypes = {
  data: PropTypes.array,
  onChange: PropTypes.func,
  multiple: PropTypes.bool
};

export default SelectField;
